module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "about-page"
  }, [_c('div', {
    staticClass: "about-page__content"
  }, [_c('div', {
    staticClass: "intro"
  }, [_c('div', {
    staticClass: "intro-wrapper"
  }, [_c('div', {
    staticClass: "intro-container"
  }, [_c('div', {
    ref: "background",
    staticClass: "intro-background"
  }), _c('div', {
    staticClass: "intro-video"
  }), _c('div', {
    ref: "content",
    staticClass: "intro-content"
  }, [_c('img', {
    staticClass: "intro-logo",
    attrs: {
      "src": require("../../assets/aurocraft-logo.svg")
    }
  }), (_vm.$content.description) ? _c('div', {
    staticClass: "intro-description",
    domProps: {
      "innerHTML": _vm._s(_vm.$content.description)
    }
  }) : _vm._e()]), _c('transition-wrapper', {
    attrs: {
      "appear": true,
      "appear-delay": "0.5"
    }
  }, [_c('scroll-marker', {
    staticClass: "intro-scroll",
    on: {
      "click": _vm.scroll
    }
  })], 1)], 1)]), (_vm.$content.media && _vm.$content.media.image) ? _c('div', {
    ref: "image",
    staticClass: "intro-image"
  }, [_c('img', {
    attrs: {
      "src": _vm.$content.media.image.url,
      "alt": "image"
    }
  })]) : _vm._e()]), _c('appearance-wrapper', [(_vm.$description) ? _c('description', {
    ref: "description",
    attrs: {
      "$content": _vm.$description
    }
  }) : _vm._e()], 1), _c('appearance-wrapper', [(_vm.$partners) ? _c('partners', {
    attrs: {
      "$content": _vm.$partners
    }
  }) : _vm._e()], 1), _c('appearance-wrapper', [(_vm.$awards) ? _c('awards', {
    attrs: {
      "$content": _vm.$awards
    }
  }) : _vm._e()], 1)], 1), _c('the-footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-423ea62a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/about/index.vue
// module id = 480
// module chunks = 0